// import { userBookingFun } from "../../../api/userAPI";
import { userBookingCount, userBookingFun } from '../../../api/userAPI';
import errorHandle from '../../../utils/errorHandle';

// stays have no status job on the server yet — go by the dates
function stayStatusShown(item) {
    const status = item?.stayStatus;
    if (status !== 'Not Yet Started') return status;
    const now = new Date();
    if (item?.endDate && new Date(item.endDate) <= now) return 'Completed';
    if (item?.startDate && new Date(item.startDate) <= now) return 'In Progress';
    return status;
}

export default async function myBookingData(typeSel, limit, offSet, setBookingData, setLoading) {
    //API call for fetching booking data of a particular user
    setLoading(true);
    try {
        const booking = await userBookingFun(typeSel, limit, offSet);
        const normalizedData = booking?.data?.map((item) => ({
            ...item,
            id: item?.actId || item?.guTourId || item?.packId || item?.campId,
            status: item?.actStatus || item?.guStatus || item?.tripStatus || stayStatusShown(item)
        }));
        setBookingData(normalizedData);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}

export async function myBookingCount(typeSel, setTotalData) {
    const bookingCount = await userBookingCount(typeSel);
    setTotalData(bookingCount.data.count);
}
